<script setup>
import {Form} from "vee-validate";
import {computed, ref, watch, watchEffect} from "vue";
import {object} from "yup";
import useValidate from "@/composables/useValidate";
import InputText from "@/base-components/Form/InputText.vue";
import Button from "@/base-components/Button";
import {FormLabel} from "@/base-components/Form";
import {useFetch} from "@/composables/useFetch.js";
import {uri} from "@/constants/config.js";

const {profile = {}} = defineProps({profile: {required: true, type: Object}})
const emits = defineEmits('update')
const isUpdating = ref(false);
const profileTemp = ref({
  'firstName': '',
  'lastName': '',
  'nationalCode': '',
  'mobile': '',
  'address': '',
  'email': ''
});
const updateValidation = object(
    useValidate(['firstName', 'lastName', 'nationalCode', 'mobile', 'address', 'email']),
);

async function tryUpdateProfile() {
  isUpdating.value = true;
  await useFetch(uri.api.user.profile.real, {body: profileTemp.value})
  isUpdating.value = false;
  emits('update')
}

function cancel() {
  Object.keys(profileTemp.value).forEach((key) => {
    profileTemp.value[key] = profile[key]
  })
}

watchEffect(() => {
    cancel()
})





</script>

<template>
  <section>
    <Form :validation-schema="updateValidation" @submit="tryUpdateProfile">
      <div class="grid md:grid-cols-3 lg:grid-cols-3 grid-cols-3 gap-2">
        <div>
          <FormLabel htmlFor="input-wizard-3">
            {{ $t('label.first-name') }}
          </FormLabel>
          <InputText class="flex-grow"
                     :label="$t('label.first-name')"
                     name="firstName"
                     :has-default-error-message="true"
                     :is-disabled="isUpdating"
                     v-model="profileTemp.firstName"/>
        </div>
        <div>
          <FormLabel htmlFor="input-wizard-3">
            {{ $t('label.last-name') }}
          </FormLabel>
          <InputText class="flex-grow"
                     :label="$t('label.last-name')"
                     name="lastName"
                     :has-default-error-message="true"
                     :is-disabled="isUpdating"
                     v-model="profileTemp.lastName"/>
        </div>
        <div>
          <FormLabel htmlFor="input-wizard-3">
            {{ $t('label.national-id') }}
          </FormLabel>
          <InputText class="flex-grow"
                     :label="$t('label.national-id')"
                     name="nationalCode"
                     :has-default-error-message="true"
                     :is-disabled="isUpdating || profile.isNationalCodeValidated"
                     :disabled="profile.isNationalCodeValidated"
                     v-model="profileTemp.nationalCode"/>
        </div>
        <div>
          <FormLabel htmlFor="input-wizard-3">
            {{ $t('label.mobile') }}
          </FormLabel>
          <InputText class="flex-grow"
                     :label="$t('label.mobile')"
                     name="mobile"
                     :has-default-error-message="true"
                     :is-disabled="isUpdating || profile.isMobileValidated"
                     :disabled="profile.isMobileValidated"
                     v-model="profileTemp.mobile"/>
        </div>
        <div>
          <FormLabel htmlFor="input-wizard-3">
            {{ $t('label.email') }}
          </FormLabel>
          <InputText class="flex-grow"
                     :label="$t('label.email')"
                     name="email"
                     :has-default-error-message="true"
                     :is-disabled="isUpdating || profile.isEmailValidated"
                     :disabled="profile.isEmailValidated"
                     v-model="profileTemp.email"/>
        </div>
        <div>
          <FormLabel htmlFor="input-wizard-3">
            {{ $t('label.address') }}
          </FormLabel>
          <InputText class="flex-grow"
                     :label="$t('label.address')"
                     name="address"
                     :has-default-error-message="true"
                     :is-disabled="isUpdating"
                     v-model="profileTemp.address"/>
        </div>
      </div>
      <div class="py-[6px]" v-if="isUpdating">
        <progress class="progress w-full progress-primary"></progress>
      </div>
      <div class="flex justify-begin gap-2 mt-5 p-5" v-else>
        <Button variant="secondary" size="sm" class="py-1.5" @click="cancel" type="button">
          {{ $t('button.cancel') }}
        </Button>
        <Button variant="primary" size="sm" type="submit">
          {{ $t('button.update') }}
        </Button>
      </div>

    </Form>
  </section>
</template>

<style scoped>

</style>